module.exports = __webpack_public_path__ + "static/media/checkout-large.11e59d88.jpg";